import { FormattedMessage } from "react-intl";

export const UnauthorizedPage = () => {
  return (
    <p>
      <FormattedMessage id="label.unauthorized-page" />
    </p>
  );
};
